import { atom } from "jotai";

interface BeaconState {
    isBeaconLoaded: boolean;
}

export const INITIAL_BEACON_STATE: BeaconState = {
    isBeaconLoaded: false,
};

export const beaconStateAtom = atom(INITIAL_BEACON_STATE);

export const setIsBeaconLoaded = (setState, isLoaded) => {
    setState((state) => {
        const newState = { ...state };

        newState.isBeaconLoaded = isLoaded;

        return newState;
    });
};
